import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../components/api/axiosInstance";
import { getPortalSession, isPortalOwner } from "./portalSession";

function CustomerDashboard() {
  const navigate = useNavigate();
  const portalOwner = useMemo(() => isPortalOwner(getPortalSession()), []);
  const [leads, setLeads] = useState([]);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [clientCount, setClientCount] = useState(0);
  const [customerCount, setCustomerCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [leadsRes, employeesRes, clientsRes, customersRes] = await Promise.all([
          axiosInstance.get("/client/leads").catch(() => ({ data: { data: [] } })),
          portalOwner
            ? axiosInstance.get("/client/employees").catch(() => ({ data: { data: [] } }))
            : Promise.resolve({ data: { data: [] } }),
          axiosInstance.get("/client/tenant-clients").catch(() => ({ data: { data: [] } })),
          axiosInstance.get("/client/tenant-customers").catch(() => ({ data: { data: [] } })),
        ]);
        if (!active) return;
        setLeads(Array.isArray(leadsRes.data?.data) ? leadsRes.data.data : []);
        const employees = Array.isArray(employeesRes.data?.data) ? employeesRes.data.data : [];
        setEmployeeCount(employees.length);
        const tenantClients = Array.isArray(clientsRes.data?.data) ? clientsRes.data.data : [];
        setClientCount(tenantClients.length);
        const tenantCustomers = Array.isArray(customersRes.data?.data) ? customersRes.data.data : [];
        setCustomerCount(tenantCustomers.length);
      } catch (err) {
        if (!active) return;
        setError(err.response?.data?.message || "Could not load dashboard data.");
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [portalOwner]);

  const cards = [
    portalOwner && { key: "employees", label: "Employees", value: employeeCount, path: "/portal/employees" },
    { key: "leads", label: "Leads", value: leads.length, path: "/portal/leads" },
    { key: "clients", label: "Clients", value: clientCount, path: "/portal/clients" },
    { key: "customers", label: "Customers", value: customerCount, path: "/portal/customers" },
  ].filter(Boolean);

  return (
    <div className="cportal-page">
      <div className="cportal-page-head">
        <h1>Dashboard</h1>
      </div>

      {error && <div className="cportal-alert cportal-alert-error">{error}</div>}

      <div className="cportal-stats">
        {cards.map((card) => (
          <button
            key={card.key}
            type="button"
            className="cportal-stat-card"
            onClick={() => navigate(card.path)}
          >
            <span className="cportal-stat-value">{loading ? "—" : card.value}</span>
            <span className="cportal-stat-label">{card.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default CustomerDashboard;
